import React from 'react';
export function Footer() {
  return <footer className="bg-[#10284D] px-4 py-12 text-center text-sm text-white/60" data-id="element-69" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-71" data-mp="3gh3n22klrk9c">⚛️ FÍSICA Y QUÍMICA LISTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-72" data-mp="36pfshssr1n3n">
          El pack docente completo de ciencias para secundaria, listo para usar en tu aula.
        </p>
        <nav aria-label="Enlaces legales" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-73" data-mp="3ucxndx7b91au">
          <a href="#terminos" className="transition-colors hover:text-white" data-id="element-74" data-mp="3lecaahklyehg">
            Términos y condiciones
          </a>
          <a href="#privacidad" className="transition-colors hover:text-white" data-id="element-75" data-mp="3qcx8kbgauo39">
            Política de privacidad
          </a>
          <a href="#contacto" className="transition-colors hover:text-white" data-id="element-76" data-mp="29yds9o7gci43">
            Contacto
          </a>
        </nav>
        <p data-id="element-77" data-mp="2ew716p053q82">© {new Date().getFullYear()} Física y Química Lista. Todos los derechos reservados.</p>
      </div>
    </footer>;
}